import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Spin, Typography, message, Button } from 'antd';
import { bikandaApi } from '../../../methods/baseuri';

const { Title, Text } = Typography;

const CompleteRegistration = () => {
	const [searchParams] = useSearchParams();
	const [loading, setLoading] = useState(true);
	const [status, setStatus] = useState<'success' | 'error' | 'idle'>('idle');
	const navigate = useNavigate();

	useEffect(() => {
		const email = searchParams.get('email');
		const password = searchParams.get('password');
		const verificationToken = searchParams.get('verificationToken');
		const registrationToken = searchParams.get('registrationToken');

		if (!email || !password || !verificationToken || !registrationToken) {
			message.error('Missing registration details in URL.');
			setStatus('error');
			setLoading(false);
			return;
		}

		const submitRegistration = async () => {
			try {
				const payload = {
					email,
					password,
					verificationToken,
					registrationToken,
				};

				const response: any = await bikandaApi.post(
					`Public/Merchant/auth/complete-registration`,
					payload
				);

				if (response.status === 200) {
					message.success('Registration completed successfully!');
					setStatus('success');
					navigate('/bikanda/login');
				} else {
					message.error('Registration failed. Please try again.');
					setStatus('error');
				}
			} catch (error: any) {
				console.error('Registration error:', error);
				message.error(
					error?.response?.data?.message ||
						'Something went wrong during registration.'
				);
				setStatus('error');
			} finally {
				setLoading(false);
			}
		};

		submitRegistration();
	}, [searchParams]);

	const renderContent = () => {
		if (loading) {
			return (
				<>
					<Spin size="large" />
					<p style={{ marginTop: 16 }}>Completing your registration...</p>
				</>
			);
		}

		if (status === 'success') {
			return (
				<>
					<Title level={3}>🎉 Success!</Title>
					<Text>Your registration is now complete. You can now log in.</Text>
					<div style={{ marginTop: 24 }}>
						<Button type="primary" onClick={() => navigate('/login')}>
							Go to Login
						</Button>
					</div>
				</>
			);
		}

		return (
			<>
				<Title level={3}>⚠️ Oops!</Title>
				<Text>
					There was an issue completing your registration. Please try again or
					contact support.
				</Text>
				<div style={{ marginTop: 24 }}>
					<Button onClick={() => window.location.reload()}>Try Again</Button>
					<Button
						type="primary"
						onClick={() => {
							console.info('contact-support');
							// navigate('/contact-support')
						}}
						style={{ marginLeft: 8 }}
					>
						Contact Support
					</Button>
				</div>
			</>
		);
	};

	return (
		<Card style={{ margin: '80px auto', maxWidth: 500, textAlign: 'center' }}>
			{renderContent()}
		</Card>
	);
};

export default CompleteRegistration;
